import './PitchGrid.css';

const ROWS = [
	['gk', 'Goalkeeper'],
	['def', 'Defenders'],
	['mid', 'Midfielders'],
	['fwd', 'Forwards'],
];

/* Kit images are served straight from the Flask static directory. */
const kitSrc = (team) => `/static/img/kits/${team}.png`;

function Player({ pick, captain, viceCaptain }) {
	const isCaptain = pick.element === captain;
	const isVice = pick.element === viceCaptain;

	return (
		<li className="player">
			{/* The armband sits on the shirt rather than in the name row, where
			    it was taking 16px away from the name on exactly the players
			    most worth reading. */}
			<span className="player__kit-wrap">
				<img
					className="player__kit"
					src={kitSrc(pick.team_name)}
					alt={pick.team_name}
					loading="lazy"
					width="56"
					height="72"
				/>
				{(isCaptain || isVice) && (
					<span
						className={`player__badge${isCaptain ? ' player__badge--captain' : ''}`}
						title={isCaptain ? 'Captain' : 'Vice-captain'}
					>
						{isCaptain ? 'C' : 'V'}
					</span>
				)}
			</span>
			<span className={`player__name${isCaptain ? ' player__name--captain' : ''}`}>
				{/* The name needs its own element: as a bare text node it becomes
				    an anonymous flex item, where text-overflow has no effect and
				    centred overflow clips both ends of the name. */}
				<span className="player__name-text" title={pick.name}>
					{pick.name}
				</span>
			</span>
			{pick.fixture?.map((fix, i) => (
				<span
					key={i}
					className="player__fixture"
					data-difficulty={fix.diff || undefined}
				>
					{fix.fixture}
				</span>
			))}
		</li>
	);
}

export default function PitchGrid({
	playingPicks,
	benchPicks,
	captain,
	viceCaptain,
	loading,
}) {
	if (!playingPicks) return null;

	return (
		<div className={`pitch${loading ? ' pitch--loading' : ''}`}>
			<div className="pitch__field">
				{ROWS.map(([key, label]) => (
					<section key={key} className="pitch__row" aria-label={label}>
						<h3 className="visually-hidden">{label}</h3>
						<ul className="pitch__line">
							{playingPicks[key]?.map((pick) => (
								<Player
									key={pick.element}
									pick={pick}
									captain={captain}
									viceCaptain={viceCaptain}
								/>
							))}
						</ul>
					</section>
				))}
			</div>

			{benchPicks?.length > 0 && (
				<section className="pitch__bench" aria-label="Bench">
					<h3 className="pitch__bench-title">Bench</h3>
					<ul className="pitch__line">
						{benchPicks.map((pick) => (
							<Player
								key={pick.element}
								pick={pick}
								captain={captain}
								viceCaptain={viceCaptain}
							/>
						))}
					</ul>
				</section>
			)}
		</div>
	);
}
